module.exports = __webpack_public_path__ + "static/media/1 封面.56c6ff4b.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/奶油乳酪抹醬/1 封面.JPG
// module id = 230
// module chunks = 0